<div class="text-align-center">
  <nz-spin nzSimple></nz-spin>
  {{ content }}
</div>